import { POST } from "../../index";

export const selectFaceAuthorize = (param) => POST("/v1/faceAuthorize/selectFaceAuthorize", param);
export const insertFaceAuthorize = (param) => POST("/v1/faceAuthorize/insertFaceAuthorize", param);
export const insertAuthorize = (param) => POST("/v1/faceAuthorize/insertAuthorize", param);
export const clearAuthorize = (param) => POST("/v1/faceAuthorize/clearAuthorize", param);
export const deleteICAuthorize = (param) => POST("/v1/faceAuthorize/deleteFaceAuthorize", param);
export const selectFaceAuthorizeRecord = (param) => POST("/v1/faceAuthorize/selectFaceAuthorizeRecord", param);
export const selectFaceAuthorizeOperation = (param) => POST("/v1/faceAuthorize/selectFaceAuthorizeOperation", param);